import { render, staticRenderFns } from "./BloqueEcommerce.vue?vue&type=template&id=66d7a6ce&scoped=true"
import script from "./BloqueEcommerce.vue?vue&type=script&lang=js"
export * from "./BloqueEcommerce.vue?vue&type=script&lang=js"
import style0 from "./BloqueEcommerce.vue?vue&type=style&index=0&id=66d7a6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7a6ce",
  null
  
)

export default component.exports